<template>
  <div v-if="activeLoading.regraterId">
    <h1>Lieferung <span class="key heavy">L{{ activeLoading.loadingId }}</span></h1>
    <ul class="output col-8 mb-0">
      <li><label class="col-3">Produkt</label> {{ getProduct(activeLoading.productId) }}</li>
      <li><label class="col-3">Aufkäufer</label> {{ getRegrater(activeLoading.regraterId) }}</li>
      <li v-if="activeLoading.deliverySlipNumber"><label class="col-3">{{ isGrain ? 'Auslagerung' : 'Lieferschein' }}</label> {{ activeLoading.deliverySlipNumber }}</li>
      <li v-if="activeLoading.licensePlateNumber"><label class="col-3">Kennzeichen</label> {{ activeLoading.licensePlateNumber }}</li>
      <li v-if="activeLoading.licensePlateTrailer"><label class="col-3">Anhänger</label> {{ activeLoading.licensePlateTrailer }}</li>
    </ul>
    <div class="w-100 mb-3">
      <button @click="editLoading()" class="edit">~</button>
    </div>

    <div v-if="!isGrain && activeLoading.vessel.length">
      <h2>Ladeliste</h2>
      <ul class="list w-100">
        <li v-for="(vessel, idx) in getLoadedVessels()"
            :key="vessel.vesselId" class="row">
          <button v-if="!finishedLoading()" @click="openDialog(
              { element: 'der Big Bag',nbr: vessel.uniqueNumber, weight: vessel.weight, uid: vessel.uniqueId})"
                  class="del col-1">-</button>
          <div class="col-1">{{ idx+1 }}</div>
          <label :class="'col-'+(finishedLoading() ? 5 : 3)">{{ vessel.uniqueNumber }} {{ vessel.supplier }}</label>
          <div class="col-2 text-right">{{ getVesselWeight(vessel) }}</div>
<!--          <span v-if="getVesselChilds(vessel.vesselId)"><br/>{{ getVesselChildsText(vessel) }}</span>-->
<!--          <div v-if="finishedLoading()" class="col-3 text-right">-->
<!--            <api-pdf-link method="bigbagslip" :elementId="vessel.uniqueId" class="float-right"/>-->
<!--          </div>-->
        </li>
      </ul>
      <div class="row mb-3">
        <div :class="'col-'+(finishedLoading() ? 6 : 5)" class="bold">Summe</div>
        <div class="col-2 bold text-right" :class="!finishedLoading() && 'pr-0'">{{ totalWeight() }} kg</div>
      </div>
      <div v-if="activeLoading.vessel.length || finishedLoading()" class="row mb-3">
        <div class="col-8">
          <api-pdf-link method="loadingslip" label="Lieferschein PDF" :elementId="activeLoading.uniqueId" class="float-right"/>
        </div>
      </div>
      <!-- todo: if alwera -->
      <!-- div v-if="finishedLoading() && loadingBatches.length">
        <div v-for="(batch, idx) in loadingBatches" :key="idx" class="row mb-3">
        <div class="col-8">
          <api-pdf-link
              method="batchstockslip"
              :label="`Partieblatt: ${batch.uniqueNumber}`"
              :elementId="batch.uniqueId"
              class="float-right"
          />
        </div>
      </div>
      </div-->
    </div>
    <div v-if="!isGrain && !finishedLoading()">
      <h2>Big Bags</h2>
      <ul class="nav" style="margin:0 0 0.5rem 0">
        <li @click="showQrReader" class="qr">
          QR-Code
          <img src="@/assets/images/icon-qr-code.svg"/>
        </li>
      </ul>
      <form @submit.prevent="saveBagLoading" class="col-8">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="bag">Big Bag</label>
          </div>
          <select
              v-model="bag"
              class="custom-select custom-select-lg" id="bag">
            <option>Auswählen..</option>
            <option
                v-for="bag in this.loadableVessels"
                :key="bag.vesselId"
                :value="bag.vesselId">
              {{ getBigBagLabel(bag) }}
            </option>
          </select>
        </div>
        <button type="submit" class="mt-1">Geladen</button>
      </form>
      <button @click="finishLoading">Abschluss</button>
    </div>
  </div>
  <div v-else-if="!finishedLoading()" class="row">
    <h1>Verladen</h1>
    <form @submit.prevent="save" class="col-8">
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="regraterId">Aufkäufer</label>
        </div>
        <select
            v-model="regraterId"
            class="custom-select custom-select-lg" id="regraterId" required>
          <option>Auswählen..</option>
          <option
              v-for="regrater in regraters"
              :key="regrater.contactId"
              :value="regrater.contactId"
          >{{ regrater.name }}</option>
        </select>
      </div>

      <div
          v-if="products.length > 1"
          class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="supplierId">Produkt</label>
        </div>
        <select
            v-model="productId"
            @change="productChanged"
            class="custom-select custom-select-lg" id="supplierId"
            required>
          <option>Auswählen..</option>
          <option
              v-for="product in products"
              :key="product.productId"
              :value="product.productId">{{ product.name }}</option>
        </select>
      </div>

      <div
          v-if="!products.length || productId === 1"
          class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="deliverySlipNumber">Lieferschein</label>
        </div>
        <input v-model="deliverySlipNumber" type="text" class="form-control form-control-lg" id="deliverySlipNumber"
               placeholder="">
      </div>

      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="truck">Kennzeichen</label>
        </div>
        <input v-model="truck" type="text" class="form-control form-control-lg" id="truck" placeholder="">
      </div>

      <div
          v-if="!products.length || productId === 1"
          class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="trailer">Kennzeichen Anhänger</label>
        </div>
        <input v-model="trailer" type="text" class="form-control form-control-lg" id="trailer" placeholder="">
      </div>

      <button type="submit">Starten</button>
    </form>
  </div>

  <div
    v-if="isGrain && loadedBatches.length > 0"
    class="row">
    <h2>Geladen</h2>
    <div class="w-100">
      <batch-list
          :batches="loadedBatches" :add-batch-enabled="false" :show-regraters="false"/>
    </div>
    <ul class="output col-8 mb-0">
      <li class="bold"><label class="col-3 bold">Menge</label> {{ globalFunctions.parseNumber(activeLoading.loadingWeight) }} kg</li>
    </ul>
  </div>

  <div
    v-if="isGrain && !loadedBatches.length && !finishedLoading()"
    class="row">
    <h2>Auslagerung</h2>
    <div
      class="w-100">
      <form @submit.prevent="saveForm" class="row">
        <!--div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="bag">Charge</label>
          </div>
          <select
              v-model="batchId"
              class="custom-select custom-select-lg" id="bag">
            <option>Auswählen..</option>
            <option
                v-for="batch in batches"
                :key="batch.batchId"
                :value="batch.batchId">
              {{ getBatchLabel(batch) }}
            </option>
          </select>
        </div-->

        <div class="input-group col-6 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="tareWeight">Tara-Gewicht</label>
          </div>
          <input v-model="tareWeight" type="number" step=".01" class="form-control form-control-lg"
                 id="tareWeight" placeholder="" @change="setTaraDateTime()">
          <div class="input-group-append">
            <span class="input-group-text">kg</span>
          </div>
        </div>
        <div class="input-group col-2 mb-3">
          <button @click="getWeightFromScale('tareWeight')" class="group-btn" type="button">Waage</button>
        </div>
        <div v-if="scaleData.tareWeightOutput" class="input-group col-8 mb-3 pl-3">
          {{ scaleData.tareWeightOutput }}
        </div>

        <div class="input-group col-4 w55 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="tareWeightDate">D</label>
          </div>
          <input v-model="tareWeightDate" class="form-control form-control-lg"
                 id="tareWeightDate" placeholder="TT.MM.JJJJ" pattern="\d{1,2}.\d{1,2}.\d{4}">
        </div>
        <div class="input-group col-4 w45 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="tareWeightTime">Z</label>
          </div>
          <input v-model="tareWeightTime" class="form-control form-control-lg"
                 id="tareWeightTime" placeholder="HH:mm">
        </div>

        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="sampleNumber">Probe Nr</label>
          </div>
          <input v-model="sampleNumber" class="form-control form-control-lg" id="sampleNumber" placeholder="">
        </div>
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="moisture">Feuchtigkeit</label>
          </div>
          <input v-model="moisture" type="number" step=".01" class="form-control form-control-lg"
                 id="moisture" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="hectoliter">Hektoliter</label>
          </div>
          <input v-model="hectoliter" type="number" step=".01" class="form-control form-control-lg"
                 id="hectoliter" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="protein">Protein</label>
          </div>
          <input v-model="protein" type="number" step=".01" class="form-control form-control-lg"
                 id="protein" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>

        <div class="input-group col-6 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="grossWeight">Brutto-Gewicht</label>
          </div>
          <input v-model="grossWeight" type="number" step=".01" class="form-control form-control-lg"
                 id="grossWeight" placeholder="" @change="setGrossDateTime()">
          <div class="input-group-append">
            <span class="input-group-text">kg</span>
          </div>
        </div>
        <div class="input-group col-2 mb-3">
          <button @click="getWeightFromScale('grossWeight')" class="group-btn" type="button">Waage</button>
        </div>
        <div v-if="scaleData.grossWeightOutput" class="input-group col-8 mb-3 pl-3">
          {{ scaleData.grossWeightOutput }}
        </div>

        <div class="input-group col-4 w55 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="grossWeightDate">D</label>
          </div>
          <input v-model="grossWeightDate" class="form-control form-control-lg"
                 id="grossWeightDate" placeholder="TT.MM.JJJJ" pattern="\d{1,2}.\d{1,2}.\d{4}">
        </div>
        <div class="input-group col-4 w45 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="grossWeightTime">Z</label>
          </div>
          <input v-model="grossWeightTime" class="form-control form-control-lg"
                 id="grossWeightTime" placeholder="HH:mm">
        </div>

        <div
            v-if="grossWeight && tareWeight"
            class="col-8">
          <h2>Gewicht</h2>
          <ul class="output col-8">
            <li class="bold">
              <label class="col-3 bold">Netto</label> {{ globalFunctions.parseNumber(totalWeight()) }} kg
            </li>
            <li
                v-if="dockage"
                class="bold">
              <label class="col-3 bold">- Besatz</label> {{ globalFunctions.parseNumber(totalMinusDockage()) }} kg
            </li>
          </ul>
        </div>

        <div v-if="loadingStored" class="col-8 mt-3 text-right">
          <img class="opened" src="@/assets/images/icon-done.svg"/>
          gespeichert
        </div>
        <button @click="saveBatchLoading" type="button" class="mt-1">Zwischenspeichern</button>
      </form>
    </div>
  </div>

  <div
      v-if="isGrain && activeLoading.loadingWeight > 0 && !finishedLoading()"
      class="row">
    <!--div v-if="canWrite" class="col-8 mb-3">
      <button @click="resetBatchLoading" class="del">-</button>
    </div-->
    <!--form class="row">
      <div class="input-group form-check mt-3">
        <input v-model="finishBatch" type="checkbox" class="form-check" id="dryerCleaned">
        <label class="form-check-label ml-2" for="dryerCleaned">Charge abschließen</label>
      </div>
    </form-->
    <button @click="finishLoading" class="done">Auslagerung abschließen</button>
  </div>
  <div
      v-else-if="isGrain && finishedLoading()"
      class="row">

    <h2>Auslagerungsschein</h2>
    <div class="col-2">{{ activeLoading.deliverySlipNumber }}</div>
    <div class="col-6 text-right">
      <api-pdf-link method="storeoutslip" :elementId="loadingId" label="PDF" class="float-right"/>
    </div>

  </div>

  <app-btn-back class="pt-2" routerLink="LoadingPage"/>
  <app-qr-reader v-if="qr" :doEmit="true" @qrRead="qrRead"/>
  <app-modal-dialog v-if="modalOpened" @abortDialog="abortDialog" @confirmDialog="confirmDialog">
    <h1>Entfernen bestätigen</h1>
    <div class="w-100">{{ modalText }}</div>
    <div class="w-100"><strong>{{ modalElement }}</strong></div>
  </app-modal-dialog>
  <popup-loading-editor v-if="loadingEditorOpened" :element="activeLoading" :regraters="regraters"
                        @abortDialog="abortLoadingEdit" @confirmDialog="saveLoadingEdit"></popup-loading-editor>
</template>

<script>
import { inject } from 'vue'
import ApiPdfLink from "@/components/ApiPdfLink";
import AppModalDialog from "@/components/AppModalDialog";
import PopupLoadingEditor from "@/components/PopupLoadingEditor";
import BatchList from "@/components/BatchList.vue";
import axios from "axios";
import CryptoJS from "crypto-js";
import dayjs from "dayjs";
// import customParseFormat from "dayjs/plugin/customParseFormat";

export default {
  name: "LoadingShow",
  components: {BatchList, AppModalDialog,ApiPdfLink,PopupLoadingEditor},
  data() {
    return {
      loadingId: null,
      regraterId: null,
      productId: 1,
      loadableVessels: null,
      activeLoading: {
        vessel: [],
      },
      loadingBatches: [],
      deliverySlipNumber: '',
      truck: '',
      trailer: '',
      bag: '',
      grossWeight: null,
      grossWeightDate: null,
      grossWeightTime: null,
      tareWeight: null,
      tareWeightDate: null,
      tareWeightTime: null,
      scaleData: {
        grossWeightOutput: null,
        grossWeightResult: null,
        grossWeightCheckDigit: null,
        tareWeightOutput: null,
        tareWeightResult: null,
        tareWeightCheckDigit: null,
      },
      loadingDone: false,
      storedBags: [],
      batchId: null,
      loadingWeight: null,
      sampleNumber: '',
      moisture: null,
      hectoliter: null,
      protein: null,
      loadingStored: false,
      finishBatch: false,
      qr: false,
      modalOpened: false,
      modalText: '',
      modalElement: '',
      modalUid: '',
      loadingEditorOpened: false,
      globalFunctions: inject('globalFunctions'),
    }
  },
  props: {
    id: {
      required: false,
      type: String
    }
  },
  async created() {
    await this.$store.dispatch('getItemList', {entityName: 'supplier'})
    await this.$store.dispatch('getItemList', {entityName: 'regrater'})
    await this.$store.dispatch('getItemList', {entityName:'product'})

    if (this.id) {
      this.loadingId = this.id
      await this.getActiveLoading()
    }

    if (!this.isGrain) {
      // this.$store.state.vessel = []
      await this.getLoadableVessels()
      await this.$store.dispatch('getItemList', {entityName: 'batch', method: 'dried'}) // performance: not loaded or loadingBatchIds, fields: key, uniqueNumber, uid
    } else {
      await this.$store.dispatch('getItemList', {entityName: 'batch', method: 'stored'})
    }

    this.createToken()
  },
  computed: {
    regraters() {
      return this.$store.state.regrater
    },
    products() {
      return this.$store.state.product
    },
    isGrain() {
      console.log(this.activeLoading,this.activeLoading.productHasFilling)
      return this.activeLoading.productId > 1 && !this.activeLoading.productHasFilling
    },
    batches() {
      return this.$store.state.batch
    },
    loadedBatches() {
      return this.activeLoading.batchId ? this.$store.state.batch.filter(batch => batch.batchId === this.activeLoading.batchId) : []
    },
    canWrite() {
      return this.$store.getters.canWrite
    },
  },
  methods: {
    // vessels() {
    //   return this.$store.state.vessel
    // },
    parseNumber(number) {
      if (parseInt(number) != number)
        return number
      else
        return parseInt(number)
    },
    editLoading() {
      this.loadingEditorOpened = true
    },
    abortLoadingEdit() {
      this.loadingEditorOpened = false
    },
    totalWeight() {
      if (this.grossWeight && this.tareWeight)
        return this.grossWeight - this.tareWeight

      const vessels = this.activeLoading.vessel
      let total = 0

      for (let idx in vessels) {
        total += parseFloat(vessels[idx]['weight'])
      }
      return this.parseNumber(total)
    },
    saveForm() {
    },
    async save() {
      const data = {
        regraterId: this.regraterId,
        productId: this.productId,
        deliverySlipNumber: this.deliverySlipNumber,
        licensePlateNumber: this.truck,
        licensePlateTrailer: this.trailer,
      }
      const response = await this.$store.dispatch('cruItem', {name: 'loading', data})
      // console.log('saved',response.id)
      this.loadingId = response.id
      this.activeLoading = {
        ...this.activeLoading,
        loadingId: response.id,
        regraterId: this.regraterId,
        productId: this.productId,
        deliverySlipNumber: this.deliverySlipNumber,
        licensePlateNumber: this.truck,
        licensePlateTrailer: this.trailer,
        label: this.deliverySlipNumber || this.truck,
        productHasFilling: response.productHasFilling,
      }
    },
    async saveLoadingEdit({regraterId, productId, deliverySlipNumber,licensePlateNumber,licensePlateTrailer}) {
      const data = {
        regraterId,deliverySlipNumber,licensePlateNumber,licensePlateTrailer
      }
      const response = await this.$store.dispatch('cruItem',
          {name: 'loading', id: this.loadingId, data: data})
      const changedRegrater = regraterId != this.activeLoading.regraterId

      this.activeLoading = {
        ...this.activeLoading,
        regraterId,
        productId,
        deliverySlipNumber,
        licensePlateNumber,
        licensePlateTrailer,
        label: deliverySlipNumber || licensePlateNumber
      }

      if (response && response.success === true) {
        this.abortLoadingEdit()
        if (changedRegrater) await this.getLoadableVessels()
      }
    },
    async saveBagLoading() {
      const data = {
        loadingId: this.loadingId
      }

      await this.$store.dispatch('cruItem', {name: 'vessel', id: this.bag, data})
      await this.getActiveLoading()

      // const bagIndex = this.storedBags.findIndex(bag => bag.id === this.bag)
      // this.storedBags.splice(bagIndex, 1)
      await this.getLoadableVessels()
    },
    async saveBatchLoading() {
      // console.log('saveBatchLoading',this.batchId,this.loadingWeight,this.finishBatch)

      if (this.grossWeight > 0 && this.tareWeight > 0) {
        this.loadingWeight = this.grossWeight - this.tareWeight
      }

      this.loadingStored = false
      const data = {
        // batchId: this.batchId,
        loadingWeight: this.loadingWeight,
        tareWeight: this.tareWeight,
        tareWeightDate: this.tareWeightDate,
        tareWeightTime: this.tareWeightTime,
        grossWeight: this.grossWeight,
        grossWeightDate: this.grossWeightDate,
        grossWeightTime: this.grossWeightTime,
        sampleNumber: this.sampleNumber,
        moisture: this.moisture,
        hectoliter: this.hectoliter,
        protein: this.protein,
      }

      if (this.scaleData.grossWeightResult) {
        data.grossWeightScale = this.scaleData.grossWeightResult;
        data.grossWeightCheckDigit = this.scaleData.grossWeightCheckDigit;
      }
      if (this.scaleData.tareWeightResult) {
        data.tareWeightScale = this.scaleData.tareWeightResult;
        data.tareWeightCheckDigit = this.scaleData.tareWeightCheckDigit;
      }

      const response = await this.$store.dispatch('cruItem', {name: 'loading', id: this.loadingId, data})
      if (response && response.success) {
        this.loadingStored = true
        // this.activeLoading.batchId = this.batchId
        this.activeLoading.loadingWeight = this.loadingWeight
      }
      // await this.getActiveLoading()
    },
    async resetBatchLoading() {
      const data = {
        batchId: 0,
        loadingWeight: 0,
      }
      const response = await this.$store.dispatch('cruItem', {name: 'loading', id: this.loadingId, data})
      if (response && response.success) {
        this.activeLoading.batchId = null
        this.activeLoading.loadingWeight = null
      }
    },
    async finishLoading() {
      const data = {
        finishedLoading: 1,
        finishBatch: this.finishBatch,
        batchId: this.activeLoading.batchId ?? this.batchId,
        loadingWeight: this.totalWeight(),
      }
      const response = await this.$store.dispatch('cruItem',
          {name: 'loading', id: this.loadingId, data})

      if (response && response.success) {
        this.activeLoading.finishedLoading = true
      }
      // this.$props.batch.bagged = true
    },
    finishedLoading() {
      // console.log('###',this.activeLoading.finishedLoading)
      if (this.activeLoading.finishedLoading == '0')
        return false

      return this.activeLoading.finishedLoading
    },
    async getActiveLoading() {
      this.activeLoading = await this.$store.dispatch('getItem', {name: 'loading', id: this.loadingId})
      this.activeLoading.label = this.activeLoading.deliverySlipNumber || this.activeLoading.truck

      console.log('getActiveLoading',this.activeLoading)
      this.grossWeight = this.activeLoading.grossWeight > 0 ? this.activeLoading.grossWeight : ''
      this.tareWeight = this.activeLoading.tareWeight > 0 ? this.activeLoading.tareWeight : ''
      this.sampleNumber = this.activeLoading.sampleNumber > 0 ? this.activeLoading.sampleNumber : ''
      this.moisture = this.activeLoading.moisture > 0 ? this.activeLoading.moisture : ''
      this.hectoliter = this.activeLoading.hectoliter > 0 ? this.activeLoading.hectoliter : ''
      this.protein = this.activeLoading.protein > 0 ? this.activeLoading.protein : ''

      if (this.activeLoading.grossWeightDateTime) this.setFieldDateTime('grossWeight', this.activeLoading.grossWeightDateTime)
      if (this.activeLoading.tareWeightDateTime) this.setFieldDateTime('tareWeight', this.activeLoading.tareWeightDateTime)

      // get batch uids
      if (this.activeLoading && this.activeLoading.vessel) {
        this.loadingBatches = []

        /*this.activeLoading.vessel.forEach(
          vessel => this.loadingBatches.filter(
              batch => batch.batchId === vessel.batchId)[0] ??
              (this.loadingBatches.push(this.$store.state.batch.filter(batch => batch.batchId === vessel.batchId)[0]))
          )*/
        this.activeLoading.vessel.forEach(vessel => {
          if (vessel.batchId) {
            const existingBatch = this.loadingBatches.find(batch => batch.batchId === vessel.batchId);
            if (!existingBatch) {
              const matchedBatch = this.$store.state.batch.find(batch => batch.batchId === vessel.batchId);
              if (matchedBatch) {
                this.loadingBatches.push(matchedBatch);
              }
            }
          }
        });

        // console.log('loadingBatches', this.loadingBatches)
      }
    },
    async getLoadableVessels() {
      //this.loadableVessels = await this.$store.dispatch('getItemList', {entityName: 'vessel', method: 'loadable', returnData: true})
      this.loadableVessels = await this.$store.dispatch('getItemsByParent',
          {entityName: 'vessel', method: 'loadable', returnData: true, regraterId: this.activeLoading.regraterId})
    },
    showQrReader() {
      this.qr = true
    },
    qrRead(params) {
      this.setBagId(params.qrString)
      this.saveBagLoading()
      this.qr = false
    },
    formattedInt(number) {
      return parseInt(number).toLocaleString('de-DE')
    },
    setBagId(id) {
      const vessel = this.loadableVessels.filter((vessel) => vessel.uniqueNumber === id)[0];

      /*const pos = id.indexOf('.')
      if (pos >= 0)
        id = id.substring(pos+1)
      if (id.indexOf('BB') === 0)
        id = id.substring(2)*/

      this.bag = vessel.vesselId
    },
    openDialog({element, nbr, weight, uid}) {
      this.modalText = 'Soll '+ element +' aus der Ladeliste entfernt werden?'
      this.modalElement = nbr + ' mit '+ this.parseNumber(weight) +' kg'
      this.modalOpened = true
      this.modalUid = uid
    },
    abortDialog() {
      this.modalOpened = false
    },
    async confirmDialog() {
      this.modalOpened = false
      this.bag = ''
      await this.$store.dispatch('delItem', {name:'loading', uid:this.modalUid})
      await this.getActiveLoading()
      await this.getLoadableVessels()
    },
    getLoadedVessels() {
      return this.activeLoading.vessel.filter(vessel => parseInt(vessel.parent_vesselId) === 0 || vessel.parent_vesselId == null)
    },
    getVesselWeight(vessel) {
      let weight = parseFloat(vessel.weight)

      if (parseFloat(vessel.parent_vesselId) > 0)
        return ''

      const childs = this.getVesselChilds(vessel.vesselId)
      if (childs) {
        for (const child of childs) {
          weight += parseFloat(child.weight)
        }
      }

      return this.parseNumber(weight) + ' kg'
    },
    getVesselChilds(vesselId) {
      const childs = this.activeLoading.vessel.filter(vessel => vessel.parent_vesselId == vesselId)

      if (childs.length > 0)
        return childs

      return null
    },
    getVesselChildsText(vessel) {
      let texts = [
        vessel.uniqueNumber + ' ' + parseInt(vessel.weight) + ' kg'
      ]
      const childs = this.getVesselChilds(vessel.vesselId)

      for (const child of childs) {
        texts.push(child['uniqueNumber'] + ' ' + this.parseNumber(child.weight) + ' kg')
      }

      return texts.join(', ')
    },
    getSupplier(id) {
      if (!id || !this.$store.state.supplier) return ''
      const item = this.$store.state.supplier.find(item => item.contactId === id)
      if (!item) return ''
      return item.name
    },
    getRegrater(id) {
      if (!id || !this.$store.state.regrater) return '–'
      const item = this.$store.state.regrater.find(item => item.contactId === id)
      if (!item) return '–'
      return item.name
    },
    getBigBagLabel(bag) {
      let label = bag.uniqueNumber +' '+ this.parseNumber(bag.weight) +' kg | '

      if (bag.stockLocation) label += bag.stockLocation +' | '

      label += bag.supplier

      if (!this.activeLoading.regraterId) label += ' › '+ bag.regrater

      return label
    },
    getBatchLabel(batch) { console.log(batch)
      return (batch.incomingStockLocation ? batch.incomingStockLocation +' ' : '')+ batch.uniqueNumber + ' ' + this.getSupplier(batch.supplierId)
    },
    getProduct(id) {
      if (!id || !this.$store.state.product) return '–'
      const item = this.$store.state.product.find(item => item.productId === id)
      if (!item) return '–'
      return item.name
    },

    setGrossDateTime() {
      if (!this.grossWeightDate) this.grossWeightDate = dayjs().format('DD.MM.YYYY')
      if (!this.grossWeightTime) this.grossWeightTime = dayjs().format('HH:mm')
    },
    setTaraDateTime() {
      if (!this.tareWeightDate) this.tareWeightDate = dayjs().format('DD.MM.YYYY')
      if (!this.tareWeightTime) this.tareWeightTime = dayjs().format('HH:mm')
    },
    setFieldDateTime(field, datetime) {
      if (datetime) {
        const customParseFormat = require('dayjs/plugin/customParseFormat')
        dayjs.extend(customParseFormat)
        this[field +'Date'] = dayjs(datetime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('DD.MM.YYYY')
        this[field +'Time'] = dayjs(datetime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('HH:mm')
      } else {
        this[field +'Date'] = dayjs().format('DD.MM.YYYY')
        this[field +'Time'] = dayjs().format('HH:mm')
      }
    },

    async getWeightFromScale(type) {
      this.scaleData[type +'Output'] = 'Verbinde. Warte auf Antwort...'
      let response = null
      // let logMessage = ''

      try {
        response = await axios.get('http://localhost:49321/api/send-weighing-cmd', {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        });

        this.scaleData[type +'Output'] = response.data; // Handle response data

        let responseData = typeof response.data === 'object' ? response.data : JSON.parse(response.data);
        this.scaleData[type +'Result'] = responseData.response;
        // clear multiple spaces into single space
        responseData.response = responseData.response.replaceAll('       ', '*');
        responseData.response = responseData.response.replaceAll('      ', '*');
        responseData.response = responseData.response.replaceAll('     ', '*');
        responseData.response = responseData.response.replaceAll('    ', '*');
        responseData.response = responseData.response.replaceAll('   ', '*');
        responseData.response = responseData.response.replaceAll('  ', '*');
        responseData.response = responseData.response.replaceAll(' ', '*');

        const responseParts = responseData.response.split('*');
        this.scaleData[type +'Output'] = 'Gewicht von Waage eingelesen.';
        this[type] = responseParts[4].slice(0, -2);
        this.scaleData[type +'CheckDigit'] = responseParts[6].slice(0, -5);

        this.setFieldDateTime(type)

        // logMessage = JSON.stringify(response.data);
      } catch (error) {
        this.scaleData[type +'Output'] = `Error: ${error.message}`; // Handle error

        // logMessage = JSON.stringify(error.response.data) +"\n\n"+ JSON.stringify(error);
      }
    },
    createToken()
    {
      const header = {
        alg: "HS256",
        typ: "JWT"
      };

      const payload = {
        data: "examplePayload",
        exp: Math.floor(Date.now() / 1000) + (60 * 60) // Token expires in 1 hour
      };

      const secret = process.env.VUE_APP_JWT_SECRET;

      // Base64URL encoding function
      const base64UrlEncode = (obj) => {
        // Regular base64 encoding
        const str = btoa(JSON.stringify(obj));
        // Convert to base64url format
        return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      };

      const headerEncoded = base64UrlEncode(header);
      const payloadEncoded = base64UrlEncode(payload);

      // Create the signature using crypto-js
      const signatureInput = `${headerEncoded}.${payloadEncoded}`;
      const signatureWordArray = CryptoJS.HmacSHA256(signatureInput, secret);

      // Convert the signature to base64 and then to base64url
      let signatureBase64 = CryptoJS.enc.Base64.stringify(signatureWordArray);
      const signatureBase64Url = signatureBase64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

      this.token = `${headerEncoded}.${payloadEncoded}.${signatureBase64Url}`;
    },
  }
}
</script>

<style scoped>

</style>